import React from 'react';
import {
  List,
  Datagrid,
  DateField,
  Show,
  TextInput,
  TabbedForm,
  FormTab,
  DateInput,
  SelectInput,
  Edit,
  SimpleShowLayout,
  PasswordInput,
  BooleanInput,
  Create,
  TextField,
  Filter,
} from 'react-admin';
import {
  ListActions,
  FootballerBulkActionButtons,
  CertificateFootballer,
  ShowFootballers as ShowPlayer,
  EditFootballers as EditPlayer,
} from '../custom/actions';
import StatIterator from '../custom/CustomItField';
import CustomChartAr from '../custom/CustomChartAr';
import { ChangeMainInfo, ChangeSecondaryInfo } from '../custom/CustomChangeFootballers';
import { PlayerPhotoCreateInput } from '../custom/PlayerPhotoInput';
import { PlayerIdentityField, PlayerDetailsField, PlayerStatusField } from '../custom/playerFields';

const choices = [
  { id: 'Вратарь', name: 'Вратарь' },
  { id: 'Защитник(ЦЗ)', name: 'Защитник(ЦЗ)' },
  { id: 'Крайний защитник', name: 'Крайний защитник (Лз,Пз)' },
  { id: 'Центральный ПЗ', name: 'Центральный Полузащитник' },
  { id: 'Атакующий ПЗ', name: 'Атакующий Полузащитник' },
  { id: 'Опорный ПЗ', name: 'Опорный Полузащитник' },
  { id: 'Фланговый ПЗ', name: 'Фланговый Полузащитник (ПП,ЛП)' },
  { id: 'Нападающий', name: 'Нападающий' },
  { id: 'Ф. Нападающий', name: 'Фланговый Нападающий' },
];

const choicesLeg = [
  { id: 'Правая', name: 'Правая' },
  { id: 'Левая', name: 'Левая' },
];

const FootballerFilter = (props) => (
  <Filter {...props} className="fs-player-filters">
    <TextInput label="Фамилия" source="lastname" alwaysOn />
    <TextInput label="Телефон / логин" source="f_email" alwaysOn />
  </Filter>
);

export const FootballersList = (props) => (
  <div className="fs-resource-page fs-resource-page--players">
    <List
      {...props}
      title="Футболисты"
      actions={<ListActions />}
      bulkActionButtons={<FootballerBulkActionButtons />}
      filters={<FootballerFilter />}
      sort={{ field: 'lastname', order: 'ASC' }}
    >
      <Datagrid className="fs-players-datagrid" expand={<FootballerDateOfPay />}>
        <PlayerIdentityField label="Игрок" />
        <PlayerDetailsField label="Команда и позиция" />
        <DateField label="Дата рождения" source="birthday" emptyText="—" />
        <PlayerStatusField label="Статус" />
        <EditPlayer />
        <CertificateFootballer />
        <ShowPlayer />
      </Datagrid>
    </List>
  </div>
);

export const FootballerShowStats = (props) => (
  <Show {...props} title="Статистика игрока" className="fs-player-statistics-page">
    <CustomChartAr source="Statistics" name={props?.lastname} />
  </Show>
);

export const FootballerDateOfPay = (props) => (
  <Show {...props} title="Последняя оплата">
    <SimpleShowLayout className="fs-payment-preview">
      <DateField label="Дата последней оплаты" source="date_of_last_pay" />
      <TextField label="Занятия / месяцы" source="number_of_lessons" />
      <TextField label="Вариант абонемента" source="variant_of_subscription" />
    </SimpleShowLayout>
  </Show>
);

const CreateMainTab = () => (
  <div className="fs-player-create-form">
    <section className="fs-form-section fs-form-section--photo">
      <div className="fs-form-section__heading">
        <div><span>ПРОФИЛЬ</span><h2>Фотография игрока</h2></div>
        <p>Используется в личном кабинете, списках и грамотах.</p>
      </div>
      <PlayerPhotoCreateInput />
    </section>

    <section className="fs-form-section">
      <div className="fs-form-section__heading">
        <div><span>ОСНОВНЫЕ ДАННЫЕ</span><h2>Новый футболист</h2></div>
        <p>Заполните данные доступа и футбольный профиль.</p>
      </div>
      <div className="fs-ra-form-grid">
        <TextInput fullWidth label="Телефон / логин" source="f_email" />
        <PasswordInput fullWidth label="Пароль" source="f_password" />
        <TextInput fullWidth source="firstname" label="Имя" />
        <TextInput fullWidth source="lastname" label="Фамилия" />
        <TextInput fullWidth label="Команда" source="team" />
        <DateInput fullWidth source="birthday" label="Дата рождения" />
        <SelectInput fullWidth label="Позиция игрока" source="playerPosition" choices={choices} />
        <SelectInput fullWidth label="Ведущая нога" source="lead_leg" choices={choicesLeg} />
        <div className="fs-ra-switch"><BooleanInput label="Активный игрок" source="Active" /></div>
      </div>
    </section>
  </div>
);

export const FootballersCreate = (props) => (
  <Create {...props} title="Создать футболиста" className="fs-player-form-page">
    <TabbedForm className="fs-player-tabs">
      <FormTab label="Игрок">
        <CreateMainTab />
      </FormTab>
      <FormTab label="Статистика">
        <StatIterator />
      </FormTab>
      <FormTab label="Оплата">
        <section className="fs-form-section">
          <div className="fs-form-section__heading">
            <div><span>ОПЛАТА</span><h2>Первичная оплата</h2></div>
            <p>При необходимости укажите дату оплаты нового игрока.</p>
          </div>
          <DateInput fullWidth label="Дата последней оплаты" source="date_of_last_pay" />
        </section>
      </FormTab>
    </TabbedForm>
  </Create>
);

export const FootballersEdit = (props) => (
  <Edit title="Редактировать футболиста" {...props} className="fs-player-form-page">
    <TabbedForm className="fs-player-tabs" toolbar={null}>
      <FormTab label="Игрок">
        <ChangeMainInfo id={props.id} />
      </FormTab>
      <FormTab label="Статистика">
        <StatIterator />
      </FormTab>
      <FormTab label="Оплата">
        <ChangeSecondaryInfo id={props.id} />
      </FormTab>
    </TabbedForm>
  </Edit>
);

export default {
  FootballersList,
  FootballersCreate,
  FootballersEdit,
  FootballerShowStats,
};
